// Calendar.tsx — Game clock readout. 1× speed is realtime: the in-game clock
// advances one second per wall-clock second (gameClock.time is game-seconds; the
// speed multiplier integrated in gameClock.ts fast-forwards it). Shown from the
// year 2200 as "03 Mar 2200 · 14:07:22" (DD Mon YYYY · HH:MM:SS).
import { useEffect, useState } from 'react';
import { gameClock } from '../state/gameClock';

const START = Date.UTC(2200, 0, 1);
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

function format(ms: number): string {
  const d = new Date(ms);
  const day = String(d.getUTCDate()).padStart(2, '0');
  const time = d.toISOString().slice(11, 19); // HH:MM:SS, UTC like the rest
  return `${day} ${MONTHS[d.getUTCMonth()]} ${d.getUTCFullYear()} · ${time}`;
}

export function Calendar() {
  const [label, setLabel] = useState(() => format(START));

  useEffect(() => {
    const id = window.setInterval(() => {
      // 1× realtime: game-seconds map 1:1 to wall-seconds (× speed via gameClock).
      setLabel(format(START + gameClock.time * 1000));
    }, 250);
    return () => window.clearInterval(id);
  }, []);

  return <div className="calendar">{label}</div>;
}
